import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import "../../Form.css";
import useForm from "react-hook-form";
import vars from "../../../utils/variables";

const NewAdmin = ({ history }) => {
  const id = history.location.state.id;
  const [error, setError] = useState(false);

  const { handleSubmit } = useForm();

  const handleFetch = () => {
    fetch(`${vars.server}/administration/newadmin/` + id, {
      method: "POST",
      body: JSON.stringify(),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (result.success) {
          history.push("/viewuser", { id: id });
        } else {
          setError(result.message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit(handleFetch)} className="formForm">
      <h1>Neuen Administrator bestimmen</h1>
      {error && <p className="errorMessage">Fehler: {error}</p>}
      <p>Der Administrator hat alle Berechtigungen und kann den Bereich der Administration einsehen.</p>
      <p>
        Um einen neuen Administrator unwiderruflich zu bestimmen, bestätigen Sie bitte mit "Administrator bestimmen".
      </p>
      <br />
      <br />
      <input type="submit" value="Administrator bestimmen" className="inputRLSubmit delete" />
    </form>
  );
};

export default withRouter(NewAdmin);
